import Root from './components/Root.jsx';
import Login from '../views/layouts/Login/index.js';
import Home from '../views/layouts/Home.jsx';
import Reports from '../views/layouts/Reports/index.js';
import FeatureFlags from '../views/layouts/FeatureFlags/index.js';

import { NotFound } from '../views/common/StatusCodes.jsx';

import organizations from './organizations.js';
import portals from './portals.js';
import users from './users.js';

import requireAuth from '~/views/enhancers/requireAuth.jsx';


const routes = [
    {
        component: Root,
        routes: [
            {
                path: '/login',
                exact: true,
                component: Login,
            },
            {
                path: '/',
                exact: true,
                component: requireAuth(Home),
            },


            {
                path: '/reports',
                exact: true,
                component: requireAuth(Reports),
            },
            {
                path: '/reports/internal/:report',
                component: requireAuth(Reports),
            },
            {
                path: '/feature_flags',
                exact: true,
                component: requireAuth(FeatureFlags),
            },
            ...organizations,
            ...portals,
            ...users,

            {
                path: '*', component: NotFound,
            },


        ],
    },
];


export default routes;
